export const LibData={
    "ListAllBrands": {
        "ABB": 1,
        "ABICOR BINZEL": 1,
        "Aim Robotics": 5,
        "Alt-Bionics": 2,
        "ARO": 1,
        "ATI": 17,
        "Atlas Copco": 1,
        "Bota": 6,
        "Brooks": 9,
        "Comau": 1,
        "Creaform": 2,
        "DYZE DESIGN": 3,
        "FerRobotics": 21,
        "Fronius": 1,
        "Kinova": 1,
        "Ligent": 1,
        "Lorch": 1,
        "Mecademic": 2,
        "Mirka": 2,
        "Niryo": 1,
        "OBARA": 1,
        "OnRobot": 19,
        "OTC Daihen": 1,
        "RobotiQ": 12,
        "SCHUNK": 8,
        "SMC": 6,
        "Spintech": 1,
        "Teknomotor": 5,
        "uFactory": 6,
        "Zimmer": 8,
        "Zivid": 10
    },
    "ListAllAxes": {
        "0": 118,
        "1": 50,
        "2": 2,
        "10": 1
    },
    "ListAllTypes": {
        "Tool": 171
    },
    "ListAllApplications": {
        "Additive Manufacturing": 8,
        "Calibration": 1,
        "Cutting": 1,
        "Deburring": 3,
        "Dispensing": 6,
        "Grinding": 6,
        "Inspection": 2,
        "Material Handling": 56,
        "Milling": 6,
        "Painting": 1,
        "Sanding": 9,
        "Screwing": 2,
        "Taping": 4,
        "Tool Changing": 19,
        "Welding": 9
    },
    "payloadMin": 1000000000.0,
    "payloadMax": 0,
    "reachMin": 1000000000.0,
    "reachMax": 0,
    "weightMin": 2,
    "weightMax": 170,
    "repeatabilityMin": 1000000000.0,
    "repeatabilityMax": 0,
    "payloadMinRobot": 1000000000.0,
    "payloadMaxRobot": 0,
    "reachMinRobot": 1000000000.0,
    "reachMaxRobot": 0,
    "weightMinRobot": 1000000000.0,
    "weightMaxRobot": 0,
    "repeatabilityMinRobot": 1000000000.0,
    "repeatabilityMaxRobot": 0,
    "DATA_ALL": {
        "Calibration-Plate-Tool": {
            "MT": "T",
            "N": "Calibration Plate Tool",
            "F": "Calibration-Plate-Tool.tool",
            "I": "Calibration-Plate-Tool.png",
            "T": "Tool",
            "A": 0,
            "W": 8,
            "AP": [
                "Calibration"
            ]
        },
        "OnRobot-Eyes-Camera": {
            "MT": "T",
            "N": "OnRobot Eyes Camera",
            "F": "OnRobot-Eyes-Camera.tool",
            "I": "OnRobot-Eyes-Camera.png",
            "B": "OnRobot",
            "M": "Eyes Camera",
            "T": "Tool",
            "A": 0,
            "AP": [
                "Inspection"
            ]
        },
        "Zivid-Two-Camera": {
            "MT": "T",
            "N": "Zivid Two Camera",
            "F": "Zivid-Two-Camera.tool",
            "I": "Zivid-Two-Camera.png",
            "B": "Zivid",
            "M": "Two Camera",
            "T": "Tool",
            "A": 0,
            "AP": [
                "Inspection"
            ]
        },
        "Generic-Laser-Cutter": {
            "MT": "T",
            "N": "Generic Laser Cutter",
            "F": "Generic-Laser-Cutter.tool",
            "I": "Generic-Laser-Cutter.png",
            "M": "Laser Cutter",
            "T": "Tool",
            "A": 0,
            "AP": [
                "Cutting"
            ]
        },
        "ATI-9150-CDB-8-11-000-Deburring-Tool-Spring": {
            "MT": "T",
            "N": "ATI 9150-CDB-8-11-000 Deburring Tool (Spring)",
            "F": "ATI-9150-CDB-8-11-000-Deburring-Tool-Spring.tool",
            "I": "ATI-9150-CDB-8-11-000-Deburring-Tool-Spring.png",
            "B": "ATI",
            "M": "9150-CDB-8-11-000 Deburring Tool (Spring)",
            "T": "Tool",
            "A": 0,
            "AP": [
                "Deburring"
            ]
        },
        "ATI-9150-CDB-8-11-ATC-Deburring-Tool-Pneumatic": {
            "MT": "T",
            "N": "ATI 9150-CDB-8-11-ATC Deburring Tool (Pneumatic)",
            "F": "ATI-9150-CDB-8-11-ATC-Deburring-Tool-Pneumatic.tool",
            "I": "ATI-9150-CDB-8-11-ATC-Deburring-Tool-Pneumatic.png",
            "B": "ATI",
            "M": "9150-CDB-8-11-ATC Deburring Tool (Pneumatic)",
            "T": "Tool",
            "A": 0,
            "AP": [
                "Deburring"
            ]
        },
        "ATI-RCE-230-Deburring-Tool-Electric": {
            "MT": "T",
            "N": "ATI RCE-230 Deburring Tool (Electric)",
            "F": "ATI-RCE-230-Deburring-Tool-Electric.tool",
            "I": "ATI-RCE-230-Deburring-Tool-Electric.png",
            "B": "ATI",
            "M": "RCE-230 Deburring Tool (Electric)",
            "T": "Tool",
            "A": 0,
            "AP": [
                "Deburring"
            ]
        },
        "Aim-Robotics-FD-310-Dispenser": {
            "MT": "T",
            "N": "Aim Robotics FD 310 Dispenser",
            "F": "Aim-Robotics-FD-310-Dispenser.tool",
            "I": "Aim-Robotics-FD-310-Dispenser.png",
            "B": "Aim Robotics",
            "M": "FD 310 Dispenser",
            "T": "Tool",
            "A": 0,
            "AP": [
                "Dispensing"
            ]
        },
        "Aim-Robotics-FD-400-Dispenser": {
            "MT": "T",
            "N": "Aim Robotics FD 400 Dispenser",
            "F": "Aim-Robotics-FD-400-Dispenser.tool",
            "I": "Aim-Robotics-FD-400-Dispenser.png",
            "B": "Aim Robotics",
            "M": "FD 400 Dispenser",
            "T": "Tool",
            "A": 0,
            "AP": [
                "Dispensing"
            ]
        },
        "Aim-Robotics-FD-High-V-Dispenser": {
            "MT": "T",
            "N": "Aim Robotics FD High-V Dispenser",
            "F": "Aim-Robotics-FD-High-V-Dispenser.tool",
            "I": "Aim-Robotics-FD-High-V-Dispenser.png",
            "B": "Aim Robotics",
            "M": "FD High-V Dispenser",
            "T": "Tool",
            "A": 0,
            "AP": [
                "Dispensing"
            ]
        },
        "Aim-Robotics-SD-30-55-Dispenser-5mm": {
            "MT": "T",
            "N": "Aim Robotics SD 30/55 Dispenser (5mm)",
            "F": "Aim-Robotics-SD-30-55-Dispenser-5mm.tool",
            "I": "Aim-Robotics-SD-30-55-Dispenser-5mm.png",
            "B": "Aim Robotics",
            "M": "SD 30/55 Dispenser (5mm)",
            "T": "Tool",
            "A": 0,
            "AP": [
                "Dispensing"
            ]
        },
        "Aim-Robotics-SD-30-55-Dispenser": {
            "MT": "T",
            "N": "Aim Robotics SD 30/55 Dispenser",
            "F": "Aim-Robotics-SD-30-55-Dispenser.tool",
            "I": "Aim-Robotics-SD-30-55-Dispenser.png",
            "B": "Aim Robotics",
            "M": "SD 30/55 Dispenser",
            "T": "Tool",
            "A": 0,
            "AP": [
                "Dispensing"
            ]
        },
        "Generic-Dispenser": {
            "MT": "T",
            "N": "Generic Dispenser",
            "F": "Generic-Dispenser.tool",
            "I": "Generic-Dispenser.png",
            "M": "Dispenser",
            "T": "Tool",
            "A": 0,
            "AP": [
                "Dispensing"
            ]
        },
        "ATI-CGV-900-Grinder": {
            "MT": "T",
            "N": "ATI CGV-900 Grinder",
            "F": "ATI-CGV-900-Grinder.tool",
            "I": "ATI-CGV-900-Grinder.png",
            "B": "ATI",
            "M": "CGV-900 Grinder",
            "T": "Tool",
            "A": 0,
            "AP": [
                "Grinding"
            ]
        },
        "FerRobotics-ACF-K-1321400-L-Grinder": {
            "MT": "T",
            "N": "FerRobotics ACF K-1321400-L Grinder",
            "F": "FerRobotics-ACF-K-1321400-L-Grinder.rdka",
            "I": "FerRobotics-ACF-K-1321400-L-Grinder.png",
            "B": "FerRobotics",
            "M": "ACF K-1321400-L Grinder",
            "T": "Tool",
            "A": 1,
            "AP": [
                "Grinding"
            ]
        },
        "FerRobotics-ACF-K-1350600-L-Grinder": {
            "MT": "T",
            "N": "FerRobotics ACF K-1350600-L Grinder",
            "F": "FerRobotics-ACF-K-1350600-L-Grinder.rdka",
            "I": "FerRobotics-ACF-K-1350600-L-Grinder.png",
            "B": "FerRobotics",
            "M": "ACF K-1350600-L Grinder",
            "T": "Tool",
            "A": 1,
            "AP": [
                "Grinding"
            ]
        },
        "FerRobotics-ACF-K-5263200-Grinder": {
            "MT": "T",
            "N": "FerRobotics ACF K-5263200 Grinder",
            "F": "FerRobotics-ACF-K-5263200-Grinder.rdka",
            "I": "FerRobotics-ACF-K-5263200-Grinder.png",
            "B": "FerRobotics",
            "M": "ACF K-5263200 Grinder",
            "T": "Tool",
            "A": 1,
            "AP": [
                "Grinding"
            ]
        },
        "FerRobotics-ACF-K-5263500-L-Grinder": {
            "MT": "T",
            "N": "FerRobotics ACF K-5263500-L Grinder",
            "F": "FerRobotics-ACF-K-5263500-L-Grinder.rdka",
            "I": "FerRobotics-ACF-K-5263500-L-Grinder.png",
            "B": "FerRobotics",
            "M": "ACF K-5263500-L Grinder",
            "T": "Tool",
            "A": 1,
            "AP": [
                "Grinding"
            ]
        },
        "FerRobotics-ACF-K-5477100-L-Grinder": {
            "MT": "T",
            "N": "FerRobotics ACF K-5477100-L Grinder",
            "F": "FerRobotics-ACF-K-5477100-L-Grinder.rdka",
            "I": "FerRobotics-ACF-K-5477100-L-Grinder.png",
            "B": "FerRobotics",
            "M": "ACF K-5477100-L Grinder",
            "T": "Tool",
            "A": 1,
            "AP": [
                "Grinding"
            ]
        },
        "YuMi-IRB-14000-Gripper": {
            "MT": "T",
            "N": "YuMi IRB 14000 Gripper",
            "F": "YuMi-IRB-14000-Gripper.robot",
            "I": "YuMi-IRB-14000-Gripper.png",
            "B": "ABB",
            "M": "IRB 14000 Gripper",
            "T": "Tool",
            "A": 1,
            "AP": [
                "Material Handling"
            ]
        },
        "Brooks-PreciseFlex-IntelliGuide-s23-Gripper": {
            "MT": "T",
            "N": "Brooks PreciseFlex IntelliGuide s23 Gripper",
            "F": "Brooks-PreciseFlex-IntelliGuide-s23-Gripper.robot",
            "I": "Brooks-PreciseFlex-IntelliGuide-s23-Gripper.png",
            "B": "Brooks",
            "M": "PreciseFlex IntelliGuide s23 Gripper",
            "T": "Tool",
            "A": 1,
            "AP": [
                "Material Handling"
            ]
        },
        "Brooks-PreciseFlex-IntelliGuide-s23D-Dual-Gripper": {
            "MT": "T",
            "N": "Brooks PreciseFlex IntelliGuide s23D Dual Gripper",
            "F": "Brooks-PreciseFlex-IntelliGuide-s23D-Dual-Gripper.rdka",
            "I": "Brooks-PreciseFlex-IntelliGuide-s23D-Dual-Gripper.png",
            "B": "Brooks",
            "M": "PreciseFlex IntelliGuide s23D Dual Gripper",
            "T": "Tool",
            "A": 2,
            "AP": [
                "Material Handling"
            ]
        },
        "Brooks-PreciseFlex-IntelliGuide-s60-Gripper": {
            "MT": "T",
            "N": "Brooks PreciseFlex IntelliGuide s60 Gripper",
            "F": "Brooks-PreciseFlex-IntelliGuide-s60-Gripper.robot",
            "I": "Brooks-PreciseFlex-IntelliGuide-s60-Gripper.png",
            "B": "Brooks",
            "M": "PreciseFlex IntelliGuide s60 Gripper",
            "T": "Tool",
            "A": 1,
            "AP": [
                "Material Handling"
            ]
        },
        "Brooks-PreciseFlex-IntelliGuide-v23-Gripper": {
            "MT": "T",
            "N": "Brooks PreciseFlex IntelliGuide v23 Gripper",
            "F": "Brooks-PreciseFlex-IntelliGuide-v23-Gripper.robot",
            "I": "Brooks-PreciseFlex-IntelliGuide-v23-Gripper.png",
            "B": "Brooks",
            "M": "PreciseFlex IntelliGuide v23 Gripper",
            "T": "Tool",
            "A": 1,
            "AP": [
                "Material Handling"
            ]
        },
        "Brooks-PreciseFlex-IntelliGuide-v60-Gripper": {
            "MT": "T",
            "N": "Brooks PreciseFlex IntelliGuide v60 Gripper",
            "F": "Brooks-PreciseFlex-IntelliGuide-v60-Gripper.robot",
            "I": "Brooks-PreciseFlex-IntelliGuide-v60-Gripper.png",
            "B": "Brooks",
            "M": "PreciseFlex IntelliGuide v60 Gripper",
            "T": "Tool",
            "A": 1,
            "AP": [
                "Material Handling"
            ]
        },
        "Comau-e-DO-Gripper-CR82442100": {
            "MT": "T",
            "N": "Comau e.DO Gripper CR82442100",
            "F": "Comau-e-DO-Gripper-CR82442100.robot",
            "I": "Comau-e-DO-Gripper-CR82442100.png",
            "B": "Comau",
            "M": "e.DO Gripper CR82442100",
            "T": "Tool",
            "A": 1,
            "AP": [
                "Material Handling"
            ]
        },
        "Generic-2-Finger-Gripper-Pencil": {
            "MT": "T",
            "N": "Generic 2-Finger Gripper (Pencil)",
            "F": "Generic-2-Finger-Gripper-Pencil.tool",
            "I": "Generic-2-Finger-Gripper-Pencil.png",
            "M": "2-Finger Gripper (Pencil)",
            "T": "Tool",
            "A": 0,
            "W": 3.5,
            "AP": [
                "Material Handling"
            ]
        },
        "Generic-2-Finger-Gripper": {
            "MT": "T",
            "N": "Generic 2-Finger Gripper",
            "F": "Generic-2-Finger-Gripper.tool",
            "I": "Generic-2-Finger-Gripper.png",
            "M": "2-Finger Gripper",
            "T": "Tool",
            "A": 0,
            "W": 2.5,
            "AP": [
                "Material Handling"
            ]
        },
        "Generic-Box-Erector-Gripper": {
            "MT": "T",
            "N": "Generic Box Erector Gripper",
            "F": "Generic-Box-Erector-Gripper.robot",
            "I": "Generic-Box-Erector-Gripper.png",
            "M": "Box Erector Gripper",
            "T": "Tool",
            "A": 1,
            "AP": [
                "Material Handling"
            ]
        },
        "Kinova-Gen3-Lite-Gripper": {
            "MT": "T",
            "N": "Kinova Gen3 Lite Gripper",
            "F": "Kinova-Gen3-Lite-Gripper.robot",
            "I": "Kinova-Gen3-Lite-Gripper.png",
            "B": "Kinova",
            "M": "Gen3 Lite Gripper",
            "T": "Tool",
            "A": 1,
            "AP": [
                "Material Handling"
            ]
        },
        "Mecademic-SCHUNK-MPG-plus-25-Gripper-Closed": {
            "MT": "T",
            "N": "Mecademic SCHUNK MPG-plus 25 Gripper (Closed)",
            "F": "Mecademic-SCHUNK-MPG-plus-25-Gripper-Closed.tool",
            "I": "Mecademic-SCHUNK-MPG-plus-25-Gripper-Closed.png",
            "B": "Mecademic",
            "M": "SCHUNK MPG-plus 25 Gripper (Closed)",
            "T": "Tool",
            "A": 0,
            "AP": [
                "Material Handling"
            ]
        },
        "Mecademic-SCHUNK-MPG-plus-25-Gripper-Mechanism": {
            "MT": "T",
            "N": "Mecademic SCHUNK MPG-plus 25 Gripper (Mechanism)",
            "F": "Mecademic-SCHUNK-MPG-plus-25-Gripper-Mechanism.robot",
            "I": "Mecademic-SCHUNK-MPG-plus-25-Gripper-Mechanism.png",
            "B": "Mecademic",
            "M": "SCHUNK MPG-plus 25 Gripper (Mechanism)",
            "T": "Tool",
            "A": 1,
            "AP": [
                "Material Handling"
            ]
        },
        "Niryo-Ned2-Gripper": {
            "MT": "T",
            "N": "Niryo Ned2 Gripper",
            "F": "Niryo-Ned2-Gripper.robot",
            "I": "Niryo-Ned2-Gripper.png",
            "B": "Niryo",
            "M": "Ned2 Gripper",
            "T": "Tool",
            "A": 1,
            "AP": [
                "Material Handling"
            ]
        },
        "OnRobot-2FG7-Gripper": {
            "MT": "T",
            "N": "OnRobot 2FG7 Gripper",
            "F": "OnRobot-2FG7-Gripper.robot",
            "I": "OnRobot-2FG7-Gripper.png",
            "B": "OnRobot",
            "M": "2FG7 Gripper",
            "T": "Tool",
            "A": 1,
            "AP": [
                "Material Handling"
            ]
        },
        "OnRobot-2FGP20-Palletizer-Gripper": {
            "MT": "T",
            "N": "OnRobot 2FGP20 Palletizer Gripper",
            "F": "OnRobot-2FGP20-Palletizer-Gripper.tool",
            "I": "OnRobot-2FGP20-Palletizer-Gripper.png",
            "B": "OnRobot",
            "M": "2FGP20 Palletizer Gripper",
            "T": "Tool",
            "A": 0,
            "AP": [
                "Material Handling"
            ]
        },
        "OnRobot-2FGP20-Slip-Sheet-Gripper": {
            "MT": "T",
            "N": "OnRobot 2FGP20 Slip Sheet Gripper",
            "F": "OnRobot-2FGP20-Slip-Sheet-Gripper.tool",
            "I": "OnRobot-2FGP20-Slip-Sheet-Gripper.png",
            "B": "OnRobot",
            "M": "2FGP20 Slip Sheet Gripper",
            "T": "Tool",
            "A": 0,
            "AP": [
                "Material Handling"
            ]
        },
        "OnRobot-Gecko-SP1-Single-Pad-Gripper": {
            "MT": "T",
            "N": "OnRobot Gecko SP1 Single Pad Gripper",
            "F": "OnRobot-Gecko-SP1-Single-Pad-Gripper.tool",
            "I": "OnRobot-Gecko-SP1-Single-Pad-Gripper.png",
            "B": "OnRobot",
            "M": "Gecko SP1 Single Pad Gripper",
            "T": "Tool",
            "A": 0,
            "AP": [
                "Material Handling"
            ]
        },
        "OnRobot-Gecko-SP3-Single-Pad-Gripper": {
            "MT": "T",
            "N": "OnRobot Gecko SP3 Single Pad Gripper",
            "F": "OnRobot-Gecko-SP3-Single-Pad-Gripper.tool",
            "I": "OnRobot-Gecko-SP3-Single-Pad-Gripper.png",
            "B": "OnRobot",
            "M": "Gecko SP3 Single Pad Gripper",
            "T": "Tool",
            "A": 0,
            "AP": [
                "Material Handling"
            ]
        },
        "OnRobot-Gecko-SP5-Single-Pad-Gripper": {
            "MT": "T",
            "N": "OnRobot Gecko SP5 Single Pad Gripper",
            "F": "OnRobot-Gecko-SP5-Single-Pad-Gripper.tool",
            "I": "OnRobot-Gecko-SP5-Single-Pad-Gripper.png",
            "B": "OnRobot",
            "M": "Gecko SP5 Single Pad Gripper",
            "T": "Tool",
            "A": 0,
            "AP": [
                "Material Handling"
            ]
        },
        "OnRobot-MG10-Magnetic-Gripper": {
            "MT": "T",
            "N": "OnRobot MG10 Magnetic Gripper",
            "F": "OnRobot-MG10-Magnetic-Gripper.tool",
            "I": "OnRobot-MG10-Magnetic-Gripper.png",
            "B": "OnRobot",
            "M": "MG10 Magnetic Gripper",
            "T": "Tool",
            "A": 0,
            "AP": [
                "Material Handling"
            ]
        },
        "OnRobot-SG-a-Soft-Gripper": {
            "MT": "T",
            "N": "OnRobot SG-a Soft Gripper",
            "F": "OnRobot-SG-a-Soft-Gripper.tool",
            "I": "OnRobot-SG-a-Soft-Gripper.png",
            "B": "OnRobot",
            "M": "SG-a Soft Gripper",
            "T": "Tool",
            "A": 0,
            "AP": [
                "Material Handling"
            ]
        },
        "OnRobot-SG-b-Soft-Gripper": {
            "MT": "T",
            "N": "OnRobot SG-b Soft Gripper",
            "F": "OnRobot-SG-b-Soft-Gripper.tool",
            "I": "OnRobot-SG-b-Soft-Gripper.png",
            "B": "OnRobot",
            "M": "SG-b Soft Gripper",
            "T": "Tool",
            "A": 0,
            "AP": [
                "Material Handling"
            ]
        },
        "OnRobot-VG10-Vacuum-Gripper": {
            "MT": "T",
            "N": "OnRobot VG10 Vacuum Gripper",
            "F": "OnRobot-VG10-Vacuum-Gripper.tool",
            "I": "OnRobot-VG10-Vacuum-Gripper.png",
            "B": "OnRobot",
            "M": "VG10 Vacuum Gripper",
            "T": "Tool",
            "A": 0,
            "AP": [
                "Material Handling"
            ]
        },
        "OnRobot-VGC10-Vacuum-Gripper": {
            "MT": "T",
            "N": "OnRobot VGC10 Vacuum Gripper",
            "F": "OnRobot-VGC10-Vacuum-Gripper.tool",
            "I": "OnRobot-VGC10-Vacuum-Gripper.png",
            "B": "OnRobot",
            "M": "VGC10 Vacuum Gripper",
            "T": "Tool",
            "A": 0,
            "AP": [
                "Material Handling"
            ]
        },
        "OnRobot-VGP20-Vacuum-Gripper": {
            "MT": "T",
            "N": "OnRobot VGP20 Vacuum Gripper",
            "F": "OnRobot-VGP20-Vacuum-Gripper.tool",
            "I": "OnRobot-VGP20-Vacuum-Gripper.png",
            "B": "OnRobot",
            "M": "VGP20 Vacuum Gripper",
            "T": "Tool",
            "A": 0,
            "AP": [
                "Material Handling"
            ]
        },
        "RobotiQ-2F-85-Gripper-Closed": {
            "MT": "T",
            "N": "RobotiQ 2F-85 Gripper (Closed)",
            "F": "RobotiQ-2F-85-Gripper-Closed.tool",
            "I": "RobotiQ-2F-85-Gripper-Closed.png",
            "B": "RobotiQ",
            "M": "2F-85 Gripper (Closed)",
            "T": "Tool",
            "A": 0,
            "AP": [
                "Material Handling"
            ]
        },
        "RobotiQ-2F-85-Gripper-Fully-Closed": {
            "MT": "T",
            "N": "RobotiQ 2F-85 Gripper (Fully Closed)",
            "F": "RobotiQ-2F-85-Gripper-Fully-Closed.tool",
            "I": "RobotiQ-2F-85-Gripper-Fully-Closed.png",
            "B": "RobotiQ",
            "M": "2F-85 Gripper (Fully Closed)",
            "T": "Tool",
            "A": 0,
            "AP": [
                "Material Handling"
            ]
        },
        "RobotiQ-2F-85-Gripper-Mechanism": {
            "MT": "T",
            "N": "RobotiQ 2F-85 Gripper (Mechanism)",
            "F": "RobotiQ-2F-85-Gripper-Mechanism.robot",
            "I": "RobotiQ-2F-85-Gripper-Mechanism.png",
            "B": "RobotiQ",
            "M": "2F-85 Gripper (Mechanism)",
            "T": "Tool",
            "A": 1,
            "AP": [
                "Material Handling"
            ]
        },
        "RobotiQ-2F-85-Gripper-Open": {
            "MT": "T",
            "N": "RobotiQ 2F-85 Gripper (Open)",
            "F": "RobotiQ-2F-85-Gripper-Open.tool",
            "I": "RobotiQ-2F-85-Gripper-Open.png",
            "B": "RobotiQ",
            "M": "2F-85 Gripper (Open)",
            "T": "Tool",
            "A": 0,
            "AP": [
                "Material Handling"
            ]
        },
        "RobotiQ-2F-140-Gripper-Closed": {
            "MT": "T",
            "N": "RobotiQ 2F-140 Gripper (Closed)",
            "F": "RobotiQ-2F-140-Gripper-Closed.tool",
            "I": "RobotiQ-2F-140-Gripper-Closed.png",
            "B": "RobotiQ",
            "M": "2F-140 Gripper (Closed)",
            "T": "Tool",
            "A": 0,
            "AP": [
                "Material Handling"
            ]
        },
        "RobotiQ-2F-140-Gripper-Mechanism": {
            "MT": "T",
            "N": "RobotiQ 2F-140 Gripper (Mechanism)",
            "F": "RobotiQ-2F-140-Gripper-Mechanism.robot",
            "I": "RobotiQ-2F-140-Gripper-Mechanism.png",
            "B": "RobotiQ",
            "M": "2F-140 Gripper (Mechanism)",
            "T": "Tool",
            "A": 1,
            "AP": [
                "Material Handling"
            ]
        },
        "RobotiQ-2F-140-Gripper-Open": {
            "MT": "T",
            "N": "RobotiQ 2F-140 Gripper (Open)",
            "F": "RobotiQ-2F-140-Gripper-Open.tool",
            "I": "RobotiQ-2F-140-Gripper-Open.png",
            "B": "RobotiQ",
            "M": "2F-140 Gripper (Open)",
            "T": "Tool",
            "A": 0,
            "AP": [
                "Material Handling"
            ]
        },
        "RobotiQ-Dual-Hand-E-Gripper": {
            "MT": "T",
            "N": "RobotiQ Dual Hand-E Gripper",
            "F": "RobotiQ-Dual-Hand-E-Gripper.rdka",
            "I": "RobotiQ-Dual-Hand-E-Gripper.png",
            "B": "RobotiQ",
            "M": "Dual Hand-E Gripper",
            "T": "Tool",
            "A": 2,
            "AP": [
                "Material Handling"
            ]
        },
        "RobotiQ-EPick-Vacuum-Gripper-1-Cup": {
            "MT": "T",
            "N": "RobotiQ EPick Vacuum Gripper (1 Cup)",
            "F": "RobotiQ-EPick-Vacuum-Gripper-1-Cup.tool",
            "I": "RobotiQ-EPick-Vacuum-Gripper-1-Cup.png",
            "B": "RobotiQ",
            "M": "EPick Vacuum Gripper (1 Cup)",
            "T": "Tool",
            "A": 0,
            "AP": [
                "Material Handling"
            ]
        },
        "RobotiQ-EPick-Vacuum-Gripper-4-Cups": {
            "MT": "T",
            "N": "RobotiQ EPick Vacuum Gripper (4 Cups)",
            "F": "RobotiQ-EPick-Vacuum-Gripper-4-Cups.tool",
            "I": "RobotiQ-EPick-Vacuum-Gripper-4-Cups.png",
            "B": "RobotiQ",
            "M": "EPick Vacuum Gripper (4 Cups)",
            "T": "Tool",
            "A": 0,
            "AP": [
                "Material Handling"
            ]
        },
        "RobotiQ-Hand-E-Gripper": {
            "MT": "T",
            "N": "RobotiQ Hand-E Gripper",
            "F": "RobotiQ-Hand-E-Gripper.robot",
            "I": "RobotiQ-Hand-E-Gripper.png",
            "B": "RobotiQ",
            "M": "Hand-E Gripper",
            "T": "Tool",
            "A": 1,
            "AP": [
                "Material Handling"
            ]
        },
        "SCHUNK-Co-act-Gripper-Example": {
            "MT": "T",
            "N": "SCHUNK Co-act Gripper (Example)",
            "F": "SCHUNK-Co-act-Gripper-Example.rdka",
            "I": "SCHUNK-Co-act-Gripper-Example.png",
            "B": "SCHUNK",
            "M": "Co-act Gripper (Example)",
            "T": "Tool",
            "A": 1,
            "AP": [
                "Material Handling"
            ]
        },
        "SCHUNK-Co-act-Gripper": {
            "MT": "T",
            "N": "SCHUNK Co-act Gripper",
            "F": "SCHUNK-Co-act-Gripper.robot",
            "I": "SCHUNK-Co-act-Gripper.png",
            "B": "SCHUNK",
            "M": "Co-act Gripper",
            "T": "Tool",
            "A": 1,
            "AP": [
                "Material Handling"
            ]
        },
        "SCHUNK-EGH-80-IOL-N-UREK-Starter-Gripper": {
            "MT": "T",
            "N": "SCHUNK EGH 80-IOL-N-UREK Starter Gripper",
            "F": "SCHUNK-EGH-80-IOL-N-UREK-Starter-Gripper.robot",
            "I": "SCHUNK-EGH-80-IOL-N-UREK-Starter-Gripper.png",
            "B": "SCHUNK",
            "M": "EGH 80-IOL-N-UREK Starter Gripper",
            "T": "Tool",
            "A": 1,
            "AP": [
                "Material Handling"
            ]
        },
        "SCHUNK-PGN-plus-E-80-Gripper": {
            "MT": "T",
            "N": "SCHUNK PGN-plus-E 80 Gripper",
            "F": "SCHUNK-PGN-plus-E-80-Gripper.robot",
            "I": "SCHUNK-PGN-plus-E-80-Gripper.png",
            "B": "SCHUNK",
            "M": "PGN-plus-E 80 Gripper",
            "T": "Tool",
            "A": 1,
            "AP": [
                "Material Handling"
            ]
        },
        "SCHUNK-PGN-plus-E-100-Gripper": {
            "MT": "T",
            "N": "SCHUNK PGN-plus-E 100 Gripper",
            "F": "SCHUNK-PGN-plus-E-100-Gripper.robot",
            "I": "SCHUNK-PGN-plus-E-100-Gripper.png",
            "B": "SCHUNK",
            "M": "PGN-plus-E 100 Gripper",
            "T": "Tool",
            "A": 1,
            "AP": [
                "Material Handling"
            ]
        },
        "SCHUNK-PGN-plus-P-40-Gripper": {
            "MT": "T",
            "N": "SCHUNK PGN-plus-P 40 Gripper",
            "F": "SCHUNK-PGN-plus-P-40-Gripper.robot",
            "I": "SCHUNK-PGN-plus-P-40-Gripper.png",
            "B": "SCHUNK",
            "M": "PGN-plus-P 40 Gripper",
            "T": "Tool",
            "A": 1,
            "AP": [
                "Material Handling"
            ]
        },
        "SCHUNK-PGN-plus-P-50-Gripper": {
            "MT": "T",
            "N": "SCHUNK PGN-plus-P 50 Gripper",
            "F": "SCHUNK-PGN-plus-P-50-Gripper.robot",
            "I": "SCHUNK-PGN-plus-P-50-Gripper.png",
            "B": "SCHUNK",
            "M": "PGN-plus-P 50 Gripper",
            "T": "Tool",
            "A": 1,
            "AP": [
                "Material Handling"
            ]
        },
        "SCHUNK-PGN-plus-P-80-1-AS-Gripper": {
            "MT": "T",
            "N": "SCHUNK PGN-plus-P 80-1-AS Gripper",
            "F": "SCHUNK-PGN-plus-P-80-1-AS-Gripper.robot",
            "I": "SCHUNK-PGN-plus-P-80-1-AS-Gripper.png",
            "B": "SCHUNK",
            "M": "PGN-plus-P 80-1-AS Gripper",
            "T": "Tool",
            "A": 1,
            "AP": [
                "Material Handling"
            ]
        },
        "SMC-MHM-25D-X7400A-Magnetic-Gripper": {
            "MT": "T",
            "N": "SMC MHM-25D-X7400A Magnetic Gripper",
            "F": "SMC-MHM-25D-X7400A-Magnetic-Gripper.tool",
            "I": "SMC-MHM-25D-X7400A-Magnetic-Gripper.png",
            "B": "SMC",
            "M": "MHM-25D-X7400A Magnetic Gripper",
            "T": "Tool",
            "A": 0,
            "AP": [
                "Material Handling"
            ]
        },
        "SMC-ZXP7A01-X1-Gripper": {
            "MT": "T",
            "N": "SMC ZXP7A01-X1 Gripper",
            "F": "SMC-ZXP7A01-X1-Gripper.robot",
            "I": "SMC-ZXP7A01-X1-Gripper.png",
            "B": "SMC",
            "M": "ZXP7A01-X1 Gripper",
            "T": "Tool",
            "A": 1,
            "AP": [
                "Material Handling"
            ]
        },
        "SMC-ZXP7A01-ZP20U-X1-Vacuum-Gripper": {
            "MT": "T",
            "N": "SMC ZXP7A01-ZP20U-X1 Vacuum Gripper",
            "F": "SMC-ZXP7A01-ZP20U-X1-Vacuum-Gripper.tool",
            "I": "SMC-ZXP7A01-ZP20U-X1-Vacuum-Gripper.png",
            "B": "SMC",
            "M": "ZXP7A01-ZP20U-X1 Vacuum Gripper",
            "T": "Tool",
            "A": 0,
            "AP": [
                "Material Handling"
            ]
        },
        "SMC-ZXP7A01-ZP25C-X1-Vacuum-Gripper": {
            "MT": "T",
            "N": "SMC ZXP7A01-ZP25C-X1 Vacuum Gripper",
            "F": "SMC-ZXP7A01-ZP25C-X1-Vacuum-Gripper.tool",
            "I": "SMC-ZXP7A01-ZP25C-X1-Vacuum-Gripper.png",
            "B": "SMC",
            "M": "ZXP7A01-ZP25C-X1 Vacuum Gripper",
            "T": "Tool",
            "A": 0,
            "AP": [
                "Material Handling"
            ]
        },
        "uFactory-Bio-Gripper": {
            "MT": "T",
            "N": "uFactory Bio Gripper",
            "F": "uFactory-Bio-Gripper.robot",
            "I": "uFactory-Bio-Gripper.png",
            "B": "uFactory",
            "M": "Bio Gripper",
            "T": "Tool",
            "A": 1,
            "AP": [
                "Material Handling"
            ]
        },
        "uFactory-Lite6-Gripper": {
            "MT": "T",
            "N": "uFactory Lite6 Gripper",
            "F": "uFactory-Lite6-Gripper.robot",
            "I": "uFactory-Lite6-Gripper.png",
            "B": "uFactory",
            "M": "Lite6 Gripper",
            "T": "Tool",
            "A": 1,
            "AP": [
                "Material Handling"
            ]
        },
        "uFactory-Lite6-Vacuum-Gripper": {
            "MT": "T",
            "N": "uFactory Lite6 Vacuum Gripper",
            "F": "uFactory-Lite6-Vacuum-Gripper.tool",
            "I": "uFactory-Lite6-Vacuum-Gripper.png",
            "B": "uFactory",
            "M": "Lite6 Vacuum Gripper",
            "T": "Tool",
            "A": 0,
            "AP": [
                "Material Handling"
            ]
        },
        "uFactory-xArm-Gripper": {
            "MT": "T",
            "N": "uFactory xArm Gripper",
            "F": "uFactory-xArm-Gripper.tool",
            "I": "uFactory-xArm-Gripper.png",
            "B": "uFactory",
            "M": "xArm Gripper",
            "T": "Tool",
            "A": 0,
            "AP": [
                "Material Handling"
            ]
        },
        "uFactory-xArm-Vacuum-Gripper": {
            "MT": "T",
            "N": "uFactory xArm Vacuum Gripper",
            "F": "uFactory-xArm-Vacuum-Gripper.tool",
            "I": "uFactory-xArm-Vacuum-Gripper.png",
            "B": "uFactory",
            "M": "xArm Vacuum Gripper",
            "T": "Tool",
            "A": 0,
            "AP": [
                "Material Handling"
            ]
        },
        "Zimmer-GEP2016IO-12-B-01-Gripper": {
            "MT": "T",
            "N": "Zimmer GEP2016IO-12-B-01 Gripper",
            "F": "Zimmer-GEP2016IO-12-B-01-Gripper.robot",
            "I": "Zimmer-GEP2016IO-12-B-01-Gripper.png",
            "B": "Zimmer",
            "M": "GEP2016IO-12-B-01 Gripper",
            "T": "Tool",
            "A": 1,
            "AP": [
                "Material Handling"
            ]
        },
        "Zimmer-HRC-03-Gripper": {
            "MT": "T",
            "N": "Zimmer HRC-03 Gripper",
            "F": "Zimmer-HRC-03-Gripper.robot",
            "I": "Zimmer-HRC-03-Gripper.png",
            "B": "Zimmer",
            "M": "HRC-03 Gripper",
            "T": "Tool",
            "A": 1,
            "AP": [
                "Material Handling"
            ]
        },
        "Generic-Paint-Sprayer": {
            "MT": "T",
            "N": "Generic Paint Sprayer",
            "F": "Generic-Paint-Sprayer.tool",
            "I": "Generic-Paint-Sprayer.png",
            "M": "Paint Sprayer",
            "T": "Tool",
            "A": 0,
            "W": 4,
            "AP": [
                "Painting"
            ]
        },
        "3D-Printer-Extruder-Tool": {
            "MT": "T",
            "N": "3D Printer Extruder Tool",
            "F": "3D-Printer-Extruder-Tool.tool",
            "I": "3D-Printer-Extruder-Tool.png",
            "T": "Tool",
            "A": 0,
            "W": 6,
            "AP": [
                "Additive Manufacturing"
            ]
        },
        "CEAD-Extruder-E25": {
            "MT": "T",
            "N": "CEAD Extruder E25",
            "F": "CEAD-Extruder-E25.tool",
            "I": "CEAD-Extruder-E25.png",
            "T": "Tool",
            "A": 0,
            "W": 30,
            "AP": [
                "Additive Manufacturing"
            ]
        },
        "CEAD-Extruder-E40": {
            "MT": "T",
            "N": "CEAD Extruder E40",
            "F": "CEAD-Extruder-E40.tool",
            "I": "CEAD-Extruder-E40.png",
            "T": "Tool",
            "A": 0,
            "W": 70,
            "AP": [
                "Additive Manufacturing"
            ]
        },
        "CEAD-Extruder-E50": {
            "MT": "T",
            "N": "CEAD Extruder E50",
            "F": "CEAD-Extruder-E50.tool",
            "I": "CEAD-Extruder-E50.png",
            "T": "Tool",
            "A": 0,
            "W": 170,
            "AP": [
                "Additive Manufacturing"
            ]
        },
        "CEAD-Extruder-S25": {
            "MT": "T",
            "N": "CEAD Extruder S25",
            "F": "CEAD-Extruder-S25.tool",
            "I": "CEAD-Extruder-S25.png",
            "T": "Tool",
            "A": 0,
            "W": 40,
            "AP": [
                "Additive Manufacturing"
            ]
        },
        "DYZE-Pulsar-Atom-Extruder-Air": {
            "MT": "T",
            "N": "DYZE Pulsar Atom Extruder Air",
            "F": "DYZE-Pulsar-Atom-Extruder-Air.tool",
            "I": "DYZE-Pulsar-Atom-Extruder-Air.png",
            "B": "DYZE DESIGN",
            "M": "Pulsar Atom Extruder Air",
            "T": "Tool",
            "A": 0,
            "AP": [
                "Additive Manufacturing"
            ]
        },
        "DYZE-Pulsar-Atom-Extruder-Liquid": {
            "MT": "T",
            "N": "DYZE Pulsar Atom Extruder Liquid",
            "F": "DYZE-Pulsar-Atom-Extruder-Liquid.tool",
            "I": "DYZE-Pulsar-Atom-Extruder-Liquid.png",
            "B": "DYZE DESIGN",
            "M": "Pulsar Atom Extruder Liquid",
            "T": "Tool",
            "A": 0,
            "AP": [
                "Additive Manufacturing"
            ]
        },
        "DYZE-Pulsar-Atom-Extruder": {
            "MT": "T",
            "N": "DYZE Pulsar Atom Extruder",
            "F": "DYZE-Pulsar-Atom-Extruder.tool",
            "I": "DYZE-Pulsar-Atom-Extruder.png",
            "B": "DYZE DESIGN",
            "M": "Pulsar Atom Extruder",
            "T": "Tool",
            "A": 0,
            "AP": [
                "Additive Manufacturing"
            ]
        },
        "ATI-AOV-10-Sander": {
            "MT": "T",
            "N": "ATI AOV-10 Sander",
            "F": "ATI-AOV-10-Sander.tool",
            "I": "ATI-AOV-10-Sander.png",
            "B": "ATI",
            "M": "AOV-10 Sander",
            "T": "Tool",
            "A": 0,
            "AP": [
                "Sanding"
            ]
        },
        "FerRobotics-ACF-K-1536000-30-R-Sander": {
            "MT": "T",
            "N": "FerRobotics ACF K-1536000-30-R-Sander",
            "F": "FerRobotics-ACF-K-1536000-30-R-Sander.robot",
            "I": "FerRobotics-ACF-K-1536000-30-R-Sander.png",
            "B": "FerRobotics",
            "M": "ACF K-1536000-30-R-Sander",
            "T": "Tool",
            "A": 1
        },
        "FerRobotics-ACF-K-5227600-L-Sander": {
            "MT": "T",
            "N": "FerRobotics ACF K-5227600-L Sander",
            "F": "FerRobotics-ACF-K-5227600-L-Sander.rdka",
            "I": "FerRobotics-ACF-K-5227600-L-Sander.png",
            "B": "FerRobotics",
            "M": "ACF K-5227600-L Sander",
            "T": "Tool",
            "A": 1,
            "AP": [
                "Sanding"
            ]
        },
        "FerRobotics-ACF-K-5227601-L-Sander": {
            "MT": "T",
            "N": "FerRobotics ACF K-5227601-L Sander",
            "F": "FerRobotics-ACF-K-5227601-L-Sander.rdka",
            "I": "FerRobotics-ACF-K-5227601-L-Sander.png",
            "B": "FerRobotics",
            "M": "ACF K-5227601-L Sander",
            "T": "Tool",
            "A": 1,
            "AP": [
                "Sanding"
            ]
        },
        "FerRobotics-ACF-K-5681900-L-Sander": {
            "MT": "T",
            "N": "FerRobotics ACF K-5681900-L-Sander",
            "F": "FerRobotics-ACF-K-5681900-L-Sander.robot",
            "I": "FerRobotics-ACF-K-5681900-L-Sander.png",
            "B": "FerRobotics",
            "M": "ACF K-5681900-L-Sander",
            "T": "Tool",
            "A": 1
        },
        "FerRobotics-ACF-K-5683000-L-Sander": {
            "MT": "T",
            "N": "FerRobotics ACF K-5683000-L-Sander",
            "F": "FerRobotics-ACF-K-5683000-L-Sander.robot",
            "I": "FerRobotics-ACF-K-5683000-L-Sander.png",
            "B": "FerRobotics",
            "M": "ACF K-5683000-L-Sander",
            "T": "Tool",
            "A": 1
        },
        "FerRobotics-ACF-K-5781400-L-Sander": {
            "MT": "T",
            "N": "FerRobotics ACF K-5781400-L-Sander",
            "F": "FerRobotics-ACF-K-5781400-L-Sander.robot",
            "I": "FerRobotics-ACF-K-5781400-L-Sander.png",
            "B": "FerRobotics",
            "M": "ACF K-5781400-L-Sander",
            "T": "Tool",
            "A": 1
        },
        "FerRobotics-ACF-K-5851000-Sander": {
            "MT": "T",
            "N": "FerRobotics ACF K-5851000-Sander",
            "F": "FerRobotics-ACF-K-5851000-Sander.robot",
            "I": "FerRobotics-ACF-K-5851000-Sander.png",
            "B": "FerRobotics",
            "M": "ACF K-5851000-Sander",
            "T": "Tool",
            "A": 1
        },
        "FerRobotics-ACF-K-NS11V00-Sander": {
            "MT": "T",
            "N": "FerRobotics ACF K-NS11V00-Sander",
            "F": "FerRobotics-ACF-K-NS11V00-Sander.robot",
            "I": "FerRobotics-ACF-K-NS11V00-Sander.png",
            "B": "FerRobotics",
            "M": "ACF K-NS11V00-Sander",
            "T": "Tool",
            "A": 1
        },
        "FerRobotics-AOK-905-Sander-Mechanism": {
            "MT": "T",
            "N": "FerRobotics AOK/905 Sander (Mechanism)",
            "F": "FerRobotics-AOK-905-Sander-Mechanism.robot",
            "I": "FerRobotics-AOK-905-Sander-Mechanism.png",
            "B": "FerRobotics",
            "M": "AOK/905 Sander (Mechanism)",
            "T": "Tool",
            "A": 1,
            "AP": [
                "Sanding"
            ]
        },
        "FerRobotics-AOK-905-Sander": {
            "MT": "T",
            "N": "FerRobotics AOK/905 Sander",
            "F": "FerRobotics-AOK-905-Sander.tool",
            "I": "FerRobotics-AOK-905-Sander.png",
            "B": "FerRobotics",
            "M": "AOK/905 Sander",
            "T": "Tool",
            "A": 0,
            "AP": [
                "Sanding"
            ]
        },
        "Mirka-AIROP-312NV-Sander": {
            "MT": "T",
            "N": "Mirka AIROP 312NV Sander",
            "F": "Mirka-AIROP-312NV-Sander.tool",
            "I": "Mirka-AIROP-312NV-Sander.png",
            "B": "Mirka",
            "M": "AIROP 312NV Sander",
            "T": "Tool",
            "A": 0,
            "AP": [
                "Sanding"
            ]
        },
        "Mirka-AIROS-650CV-Sander": {
            "MT": "T",
            "N": "Mirka AIROS 650CV Sander",
            "F": "Mirka-AIROS-650CV-Sander.tool",
            "I": "Mirka-AIROS-650CV-Sander.png",
            "B": "Mirka",
            "M": "AIROS 650CV Sander",
            "T": "Tool",
            "A": 0,
            "AP": [
                "Sanding"
            ]
        },
        "OnRobot-Sander": {
            "MT": "T",
            "N": "OnRobot Sander",
            "F": "OnRobot-Sander.tool",
            "I": "OnRobot-Sander.png",
            "B": "OnRobot",
            "M": "Sander",
            "T": "Tool",
            "A": 0,
            "AP": [
                "Sanding"
            ]
        },
        "RobotiQ-Sanding-Kit": {
            "MT": "T",
            "N": "RobotiQ Sanding Kit",
            "F": "RobotiQ-Sanding-Kit.tool",
            "I": "RobotiQ-Sanding-Kit.png",
            "B": "RobotiQ",
            "M": "Sanding Kit",
            "T": "Tool",
            "A": 0,
            "AP": [
                "Sanding"
            ]
        },
        "Atlas-Copco-Nutrunner-Screwdriver": {
            "MT": "T",
            "N": "Atlas Copco Nutrunner Screwdriver",
            "F": "Atlas-Copco-Nutrunner-Screwdriver.tool",
            "I": "Atlas-Copco-Nutrunner-Screwdriver.png",
            "B": "Atlas Copco",
            "M": "Nutrunner Screwdriver",
            "T": "Tool",
            "A": 0,
            "AP": [
                "Screwing"
            ]
        },
        "OnRobot-Screwdriver": {
            "MT": "T",
            "N": "OnRobot Screwdriver",
            "F": "OnRobot-Screwdriver.tool",
            "I": "OnRobot-Screwdriver.png",
            "B": "OnRobot",
            "M": "Screwdriver",
            "T": "Tool",
            "A": 0,
            "AP": [
                "Screwing"
            ]
        },
        "Spintech-Spindle": {
            "MT": "T",
            "N": "Spintech Spindle",
            "F": "Spintech-Spindle.tool",
            "I": "Spintech-Spindle.png",
            "B": "Spintech",
            "M": "Spindle",
            "T": "Tool",
            "A": 0,
            "AP": [
                "Milling"
            ]
        },
        "Teknomotor-ATC71-C-LN-Spindle": {
            "MT": "T",
            "N": "Teknomotor ATC71-C-LN Spindle",
            "F": "Teknomotor-ATC71-C-LN-Spindle.tool",
            "I": "Teknomotor-ATC71-C-LN-Spindle.png",
            "B": "Teknomotor",
            "M": "ATC71-C-LN Spindle",
            "T": "Tool",
            "A": 0,
            "AP": [
                "Milling"
            ]
        },
        "Teknomotor-ATC710039-Spindle": {
            "MT": "T",
            "N": "Teknomotor ATC710039 Spindle",
            "F": "Teknomotor-ATC710039-Spindle.tool",
            "I": "Teknomotor-ATC710039-Spindle.png",
            "B": "Teknomotor",
            "M": "ATC710039 Spindle",
            "T": "Tool",
            "A": 0,
            "AP": [
                "Milling"
            ]
        },
        "Teknomotor-C31-40-C-DBL-ER20-Spindle": {
            "MT": "T",
            "N": "Teknomotor C31/40-C-DBL-ER20 Spindle",
            "F": "Teknomotor-C31-40-C-DBL-ER20-Spindle.tool",
            "I": "Teknomotor-C31-40-C-DBL-ER20-Spindle.png",
            "B": "Teknomotor",
            "M": "C31/40-C-DBL-ER20 Spindle",
            "T": "Tool",
            "A": 0,
            "AP": [
                "Milling"
            ]
        },
        "Teknomotor-QTC-C4147-C-DB-Spindle": {
            "MT": "T",
            "N": "Teknomotor QTC C4147-C-DB Spindle",
            "F": "Teknomotor-QTC-C4147-C-DB-Spindle.tool",
            "I": "Teknomotor-QTC-C4147-C-DB-Spindle.png",
            "B": "Teknomotor",
            "M": "QTC C4147-C-DB Spindle",
            "T": "Tool",
            "A": 0,
            "AP": [
                "Milling"
            ]
        },
        "Teknomotor-QTC-C5160-D-2DBS-Spindle": {
            "MT": "T",
            "N": "Teknomotor QTC-C5160-D-2DBS Spindle",
            "F": "Teknomotor-QTC-C5160-D-2DBS-Spindle.tool",
            "I": "Teknomotor-QTC-C5160-D-2DBS-Spindle.png",
            "B": "Teknomotor",
            "M": "QTC-C5160-D-2DBS Spindle",
            "T": "Tool",
            "A": 0,
            "AP": [
                "Milling"
            ]
        },
        "ATI-QC-5-Tool-Changer-Master": {
            "MT": "T",
            "N": "ATI QC-5 Tool Changer (Master)",
            "F": "ATI-QC-5-Tool-Changer-Master.tool",
            "I": "ATI-QC-5-Tool-Changer-Master.png",
            "B": "ATI",
            "M": "QC-5 Tool Changer (Master)",
            "T": "Tool",
            "A": 0,
            "AP": [
                "Tool Changing"
            ]
        },
        "ATI-QC-5-Tool-Changer-Tool": {
            "MT": "T",
            "N": "ATI QC-5 Tool Changer (Tool)",
            "F": "ATI-QC-5-Tool-Changer-Tool.tool",
            "I": "ATI-QC-5-Tool-Changer-Tool.png",
            "B": "ATI",
            "M": "QC-5 Tool Changer (Tool)",
            "T": "Tool",
            "A": 0,
            "AP": [
                "Tool Changing"
            ]
        },
        "ATI-QC-7-Tool-Changer-Master-B": {
            "MT": "T",
            "N": "ATI QC-7 Tool Changer (Master B)",
            "F": "ATI-QC-7-Tool-Changer-Master-B.tool",
            "I": "ATI-QC-7-Tool-Changer-Master-B.png",
            "B": "ATI",
            "M": "QC-7 Tool Changer (Master B)",
            "T": "Tool",
            "A": 0,
            "AP": [
                "Tool Changing"
            ]
        },
        "ATI-QC-7-Tool-Changer-Master": {
            "MT": "T",
            "N": "ATI QC-7 Tool Changer (Master)",
            "F": "ATI-QC-7-Tool-Changer-Master.tool",
            "I": "ATI-QC-7-Tool-Changer-Master.png",
            "B": "ATI",
            "M": "QC-7 Tool Changer (Master)",
            "T": "Tool",
            "A": 0,
            "AP": [
                "Tool Changing"
            ]
        },
        "ATI-QC-7-Tool-Changer-Tool-B": {
            "MT": "T",
            "N": "ATI QC-7 Tool Changer (Tool B)",
            "F": "ATI-QC-7-Tool-Changer-Tool-B.tool",
            "I": "ATI-QC-7-Tool-Changer-Tool-B.png",
            "B": "ATI",
            "M": "QC-7 Tool Changer (Tool B)",
            "T": "Tool",
            "A": 0,
            "AP": [
                "Tool Changing"
            ]
        },
        "ATI-QC-7-Tool-Changer-Tool": {
            "MT": "T",
            "N": "ATI QC-7 Tool Changer (Tool)",
            "F": "ATI-QC-7-Tool-Changer-Tool.tool",
            "I": "ATI-QC-7-Tool-Changer-Tool.png",
            "B": "ATI",
            "M": "QC-7 Tool Changer (Tool)",
            "T": "Tool",
            "A": 0,
            "AP": [
                "Tool Changing"
            ]
        },
        "ATI-QC-11-Tool-Changer-Master-Euro": {
            "MT": "T",
            "N": "ATI QC-11 Tool Changer (Master Euro)",
            "F": "ATI-QC-11-Tool-Changer-Master-Euro.tool",
            "I": "ATI-QC-11-Tool-Changer-Master-Euro.png",
            "B": "ATI",
            "M": "QC-11 Tool Changer (Master Euro)",
            "T": "Tool",
            "A": 0,
            "AP": [
                "Tool Changing"
            ]
        },
        "ATI-QC-11-Tool-Changer-Master": {
            "MT": "T",
            "N": "ATI QC-11 Tool Changer (Master)",
            "F": "ATI-QC-11-Tool-Changer-Master.tool",
            "I": "ATI-QC-11-Tool-Changer-Master.png",
            "B": "ATI",
            "M": "QC-11 Tool Changer (Master)",
            "T": "Tool",
            "A": 0,
            "AP": [
                "Tool Changing"
            ]
        },
        "ATI-QC-11-Tool-Changer-Tool-Euro": {
            "MT": "T",
            "N": "ATI QC-11 Tool Changer (Tool Euro)",
            "F": "ATI-QC-11-Tool-Changer-Tool-Euro.tool",
            "I": "ATI-QC-11-Tool-Changer-Tool-Euro.png",
            "B": "ATI",
            "M": "QC-11 Tool Changer (Tool Euro)",
            "T": "Tool",
            "A": 0,
            "AP": [
                "Tool Changing"
            ]
        },
        "ATI-QC-11-Tool-Changer-Tool": {
            "MT": "T",
            "N": "ATI QC-11 Tool Changer (Tool)",
            "F": "ATI-QC-11-Tool-Changer-Tool.tool",
            "I": "ATI-QC-11-Tool-Changer-Tool.png",
            "B": "ATI",
            "M": "QC-11 Tool Changer (Tool)",
            "T": "Tool",
            "A": 0,
            "AP": [
                "Tool Changing"
            ]
        },
        "ATI-QC-22-Tool-Changer-Tool": {
            "MT": "T",
            "N": "ATI QC-22 Tool Changer (Tool)",
            "F": "ATI-QC-22-Tool-Changer-Tool.tool",
            "I": "ATI-QC-22-Tool-Changer-Tool.png",
            "B": "ATI",
            "M": "QC-22 Tool Changer (Tool)",
            "T": "Tool",
            "A": 0,
            "AP": [
                "Tool Changing"
            ]
        },
        "OnRobot-Dual-Quick-Tool-Changer": {
            "MT": "T",
            "N": "OnRobot Dual Quick Tool Changer",
            "F": "OnRobot-Dual-Quick-Tool-Changer.tool",
            "I": "OnRobot-Dual-Quick-Tool-Changer.png",
            "B": "OnRobot",
            "M": "Dual Quick Tool Changer",
            "T": "Tool",
            "A": 0,
            "AP": [
                "Tool Changing"
            ]
        },
        "OnRobot-Quick-Tool-Changer-Robot": {
            "MT": "T",
            "N": "OnRobot Quick Tool Changer (Robot)",
            "F": "OnRobot-Quick-Tool-Changer-Robot.tool",
            "I": "OnRobot-Quick-Tool-Changer-Robot.png",
            "B": "OnRobot",
            "M": "Quick Tool Changer (Robot)",
            "T": "Tool",
            "A": 0,
            "AP": [
                "Tool Changing"
            ]
        },
        "Zimmer-FWR50F-Tool-Changer-Master": {
            "MT": "T",
            "N": "Zimmer FWR50F Tool Changer (Master)",
            "F": "Zimmer-FWR50F-Tool-Changer-Master.tool",
            "I": "Zimmer-FWR50F-Tool-Changer-Master.png",
            "B": "Zimmer",
            "M": "FWR50F Tool Changer (Master)",
            "T": "Tool",
            "A": 0,
            "AP": [
                "Tool Changing"
            ]
        },
        "Zimmer-FWR50L-Tool-Changer-Tool": {
            "MT": "T",
            "N": "Zimmer FWR50L Tool Changer (Tool)",
            "F": "Zimmer-FWR50L-Tool-Changer-Tool.tool",
            "I": "Zimmer-FWR50L-Tool-Changer-Tool.png",
            "B": "Zimmer",
            "M": "FWR50L Tool Changer (Tool)",
            "T": "Tool",
            "A": 0,
            "AP": [
                "Tool Changing"
            ]
        },
        "Zimmer-LWR50F-01-03-A-Tool-Changer-Master": {
            "MT": "T",
            "N": "Zimmer LWR50F-01-03-A Tool Changer (Master)",
            "F": "Zimmer-LWR50F-01-03-A-Tool-Changer-Master.tool",
            "I": "Zimmer-LWR50F-01-03-A-Tool-Changer-Master.png",
            "B": "Zimmer",
            "M": "LWR50F-01-03-A Tool Changer (Master)",
            "T": "Tool",
            "A": 0,
            "AP": [
                "Tool Changing"
            ]
        },
        "Zimmer-LWR50L-22-0001-A-Tool-Changer-Tool": {
            "MT": "T",
            "N": "Zimmer LWR50L-22-0001-A Tool Changer (Tool)",
            "F": "Zimmer-LWR50L-22-0001-A-Tool-Changer-Tool.robot",
            "I": "Zimmer-LWR50L-22-0001-A-Tool-Changer-Tool.png",
            "B": "Zimmer",
            "M": "LWR50L-22-0001-A Tool Changer (Tool)",
            "T": "Tool",
            "A": 1,
            "AP": [
                "Tool Changing"
            ]
        },
        "Zimmer-WWR50F-B-Tool-Changer-Master": {
            "MT": "T",
            "N": "Zimmer WWR50F-B Tool Changer (Master)",
            "F": "Zimmer-WWR50F-B-Tool-Changer-Master.tool",
            "I": "Zimmer-WWR50F-B-Tool-Changer-Master.png",
            "B": "Zimmer",
            "M": "WWR50F-B Tool Changer (Master)",
            "T": "Tool",
            "A": 0,
            "AP": [
                "Tool Changing"
            ]
        },
        "Zimmer-WWR50L-B-Tool-Changer-Tool": {
            "MT": "T",
            "N": "Zimmer WWR50L-B Tool Changer (Tool)",
            "F": "Zimmer-WWR50L-B-Tool-Changer-Tool.tool",
            "I": "Zimmer-WWR50L-B-Tool-Changer-Tool.png",
            "B": "Zimmer",
            "M": "WWR50L-B Tool Changer (Tool)",
            "T": "Tool",
            "A": 0,
            "AP": [
                "Tool Changing"
            ]
        },
        "Abicor-Binzel-45deg-Welding-Gun": {
            "MT": "T",
            "N": "Abicor Binzel 45deg Welding Gun",
            "F": "Abicor-Binzel-45deg-Welding-Gun.tool",
            "I": "Abicor-Binzel-45deg-Welding-Gun.png",
            "B": "ABICOR BINZEL",
            "M": "45deg Welding Gun",
            "T": "Tool",
            "A": 0,
            "AP": [
                "Welding"
            ]
        },
        "ARO-Spot-Welding-Gun": {
            "MT": "T",
            "N": "ARO Spot Welding Gun",
            "F": "ARO-Spot-Welding-Gun.robot",
            "I": "ARO-Spot-Welding-Gun.png",
            "B": "ARO",
            "M": "Spot Welding Gun",
            "T": "Tool",
            "A": 1,
            "AP": [
                "Welding"
            ]
        },
        "Fronius-MTB500i-Welding-Gun": {
            "MT": "T",
            "N": "Fronius MTB500i Welding Gun",
            "F": "Fronius-MTB500i-Welding-Gun.tool",
            "I": "Fronius-MTB500i-Welding-Gun.png",
            "B": "Fronius",
            "M": "MTB500i Welding Gun",
            "T": "Tool",
            "A": 0,
            "AP": [
                "Welding"
            ]
        },
        "Generic-Welding-Gun-Over-arm": {
            "MT": "T",
            "N": "Generic Welding Gun (Over-arm)",
            "F": "Generic-Welding-Gun-Over-arm.tool",
            "I": "Generic-Welding-Gun-Over-arm.png",
            "M": "Welding Gun (Over-arm)",
            "T": "Tool",
            "A": 0,
            "W": 3.0,
            "AP": [
                "Welding"
            ]
        },
        "Generic-Welding-Gun-Through-arm": {
            "MT": "T",
            "N": "Generic Welding Gun (Through-arm)",
            "F": "Generic-Welding-Gun-Through-arm.tool",
            "I": "Generic-Welding-Gun-Through-arm.png",
            "M": "Welding Gun (Through-arm)",
            "T": "Tool",
            "A": 0,
            "AP": [
                "Welding"
            ]
        },
        "Ligent-Welding-Tool": {
            "MT": "T",
            "N": "Ligent Welding Tool",
            "F": "Ligent-Welding-Tool.tool",
            "I": "Ligent-Welding-Tool.png",
            "B": "Ligent",
            "M": "Welding Tool",
            "T": "Tool",
            "A": 0,
            "AP": [
                "Welding"
            ]
        },
        "Lorch-LMR-450-W-Welding-Gun": {
            "MT": "T",
            "N": "Lorch LMR 450 W Welding Gun",
            "F": "Lorch-LMR-450-W-Welding-Gun.tool",
            "I": "Lorch-LMR-450-W-Welding-Gun.png",
            "B": "Lorch",
            "M": "LMR 450 W Welding Gun",
            "T": "Tool",
            "A": 0,
            "AP": [
                "Welding"
            ]
        },
        "OBARA-Spot-Welding-Gun": {
            "MT": "T",
            "N": "OBARA Spot Welding Gun",
            "F": "OBARA-Spot-Welding-Gun.robot",
            "I": "OBARA-Spot-Welding-Gun.png",
            "B": "OBARA",
            "M": "Spot Welding Gun",
            "T": "Tool",
            "A": 1,
            "AP": [
                "Welding"
            ]
        },
        "OTC-Daihen-FD-84-Welding-Gun": {
            "MT": "T",
            "N": "OTC Daihen FD-84 Welding Gun",
            "F": "OTC-Daihen-FD-84-Welding-Gun.tool",
            "I": "OTC-Daihen-FD-84-Welding-Gun.png",
            "B": "OTC Daihen",
            "M": "FD-84 Welding Gun",
            "T": "Tool",
            "A": 0,
            "AP": [
                "Welding"
            ]
        },
        "Alt-Bionics-Robotic-Hand-Tool": {
            "MT": "T",
            "N": "Alt-Bionics Robotic Hand Tool",
            "F": "Alt-Bionics-Robotic-Hand-Tool.tool",
            "I": "Alt-Bionics-Robotic-Hand-Tool.png",
            "B": "Alt-Bionics",
            "M": "Robotic Hand (Solid)",
            "T": "Tool",
            "A": 0
        },
        "Alt-Bionics-Robotic-Hand": {
            "MT": "T",
            "N": "Alt-Bionics Robotic Hand",
            "F": "Alt-Bionics-Robotic-Hand.rdka",
            "I": "Alt-Bionics-Robotic-Hand.png",
            "B": "Alt-Bionics",
            "M": "Robotic Hand",
            "T": "Tool",
            "A": 10
        },
        "ATI-9150-RC-300": {
            "MT": "T",
            "N": "ATI 9150-RC-300",
            "F": "ATI-9150-RC-300.tool",
            "I": "ATI-9150-RC-300.png",
            "B": "ATI",
            "M": "9150-RC-300",
            "T": "Tool",
            "A": 0
        },
        "Bota-ACC-KIN-GEN3": {
            "MT": "T",
            "N": "Bota ACC-KIN-GEN3",
            "F": "Bota-ACC-KIN-GEN3.tool",
            "I": "Bota-ACC-KIN-GEN3.png",
            "B": "Bota",
            "M": "ACC-KIN-GEN3",
            "T": "Tool",
            "A": 0
        },
        "Bota-ACC-LAX-ISO-9409-1-50-4-M6": {
            "MT": "T",
            "N": "Bota ACC-LAX-ISO-9409-1-50-4-M6",
            "F": "Bota-ACC-LAX-ISO-9409-1-50-4-M6.tool",
            "I": "Bota-ACC-LAX-ISO-9409-1-50-4-M6.png",
            "B": "Bota",
            "M": "ACC-LAX-ISO-9409-1-50-4-M6",
            "T": "Tool",
            "A": 0
        },
        "Bota-ACC-STAUBLI-TX2-40": {
            "MT": "T",
            "N": "Bota ACC-STAUBLI-TX2-40",
            "F": "Bota-ACC-STAUBLI-TX2-40.tool",
            "I": "Bota-ACC-STAUBLI-TX2-40.png",
            "B": "Bota",
            "M": "ACC-STAUBLI-TX2-40",
            "T": "Tool",
            "A": 0
        },
        "Bota-BFT-SENS-xxx-M8": {
            "MT": "T",
            "N": "Bota BFT-SENS-xxx-M8",
            "F": "Bota-BFT-SENS-xxx-M8.tool",
            "I": "Bota-BFT-SENS-xxx-M8.png",
            "B": "Bota",
            "M": "BFT-SENS-xxx-M8",
            "T": "Tool",
            "A": 0
        },
        "Bota-KIT-MIPS-MECA": {
            "MT": "T",
            "N": "Bota KIT-MIPS-MECA",
            "F": "Bota-KIT-MIPS-MECA.tool",
            "I": "Bota-KIT-MIPS-MECA.png",
            "B": "Bota",
            "M": "KIT-MIPS-MECA",
            "T": "Tool",
            "A": 0
        },
        "Bota-LAX-UR20": {
            "MT": "T",
            "N": "Bota LAX-UR20",
            "F": "Bota-LAX-UR20.tool",
            "I": "Bota-LAX-UR20.png",
            "B": "Bota",
            "M": "LAX-UR20",
            "T": "Tool",
            "A": 0
        },
        "Brooks-PreciseFlex-400-ISO-Flange": {
            "MT": "T",
            "N": "Brooks PreciseFlex 400 ISO Flange",
            "F": "Brooks-PreciseFlex-400-ISO-Flange.tool",
            "I": "Brooks-PreciseFlex-400-ISO-Flange.png",
            "B": "Brooks",
            "M": "PreciseFlex 400 ISO Flange",
            "T": "Tool",
            "A": 0
        },
        "Brooks-PreciseFlex-3400-ISO-Flange": {
            "MT": "T",
            "N": "Brooks PreciseFlex 3400 ISO Flange",
            "F": "Brooks-PreciseFlex-3400-ISO-Flange.tool",
            "I": "Brooks-PreciseFlex-3400-ISO-Flange.png",
            "B": "Brooks",
            "M": "PreciseFlex 3400 ISO Flange",
            "T": "Tool",
            "A": 0
        },
        "Brooks-PreciseFlex-DD-4-axis-ISO-Flange": {
            "MT": "T",
            "N": "Brooks PreciseFlex DD 4-axis ISO Flange",
            "F": "Brooks-PreciseFlex-DD-4-axis-ISO-Flange.tool",
            "I": "Brooks-PreciseFlex-DD-4-axis-ISO-Flange.png",
            "B": "Brooks",
            "M": "PreciseFlex DD 4-axis ISO Flange",
            "T": "Tool",
            "A": 0
        },
        "Brooks-PreciseFlex-IntelliGuide-ISO-Flange": {
            "MT": "T",
            "N": "Brooks PreciseFlex IntelliGuide ISO Flange",
            "F": "Brooks-PreciseFlex-IntelliGuide-ISO-Flange.tool",
            "I": "Brooks-PreciseFlex-IntelliGuide-ISO-Flange.png",
            "B": "Brooks",
            "M": "PreciseFlex IntelliGuide ISO Flange",
            "T": "Tool",
            "A": 0
        },
        "Creaform-MetraSCAN-Field-of-view": {
            "MT": "T",
            "N": "Creaform MetraSCAN Field-of-view",
            "F": "Creaform-MetraSCAN-Field-of-view.tool",
            "I": "Creaform-MetraSCAN-Field-of-view.png",
            "B": "Creaform",
            "M": "MetraSCAN Field-of-view",
            "T": "Tool",
            "A": 0
        },
        "Creaform-MetraSCAN": {
            "MT": "T",
            "N": "Creaform MetraSCAN",
            "F": "Creaform-MetraSCAN.tool",
            "I": "Creaform-MetraSCAN.png",
            "B": "Creaform",
            "M": "MetraSCAN",
            "T": "Tool",
            "A": 0
        },
        "FerRobotics-ATK-201-L-015-Taping-Tool": {
            "MT": "T",
            "N": "FerRobotics ATK 201-L-015 Taping Tool",
            "F": "FerRobotics-ATK-201-L-015-Taping-Tool.robot",
            "I": "FerRobotics-ATK-201-L-015-Taping-Tool.png",
            "B": "FerRobotics",
            "M": "ATK 201-L-015 Taping Tool",
            "T": "Tool",
            "A": 1,
            "AP": [
                "Taping"
            ]
        },
        "FerRobotics-ATK-201-L-027-Taping-Tool": {
            "MT": "T",
            "N": "FerRobotics ATK 201-L-027-Taping-Tool",
            "F": "FerRobotics-ATK-201-L-027-Taping-Tool.robot",
            "I": "FerRobotics-ATK-201-L-027-Taping-Tool.png",
            "B": "FerRobotics",
            "M": "ATK 201-L-027-Taping-Tool",
            "T": "Tool",
            "A": 1
        },
        "FerRobotics-ATK-201-L-065-Taping-Tool": {
            "MT": "T",
            "N": "FerRobotics ATK 201-L-065 Taping Tool",
            "F": "FerRobotics-ATK-201-L-065-Taping-Tool.robot",
            "I": "FerRobotics-ATK-201-L-065-Taping-Tool.png",
            "B": "FerRobotics",
            "M": "ATK 201-L-065 Taping Tool",
            "T": "Tool",
            "A": 1,
            "AP": [
                "Taping"
            ]
        },
        "FerRobotics-ATK-201-R-015-Taping-Tool": {
            "MT": "T",
            "N": "FerRobotics ATK 201-R-015 Taping Tool",
            "F": "FerRobotics-ATK-201-R-015-Taping-Tool.robot",
            "I": "FerRobotics-ATK-201-R-015-Taping-Tool.png",
            "B": "FerRobotics",
            "M": "ATK 201-R-015 Taping Tool",
            "T": "Tool",
            "A": 1,
            "AP": [
                "Taping"
            ]
        },
        "FerRobotics-ATK-201-R-027-Taping-Tool": {
            "MT": "T",
            "N": "FerRobotics ATK 201-R-027-Taping-Tool",
            "F": "FerRobotics-ATK-201-R-027-Taping-Tool.robot",
            "I": "FerRobotics-ATK-201-R-027-Taping-Tool.png",
            "B": "FerRobotics",
            "M": "ATK 201-R-027-Taping-Tool",
            "T": "Tool",
            "A": 1
        },
        "FerRobotics-ATK-201-R-065-Taping-Tool": {
            "MT": "T",
            "N": "FerRobotics ATK 201-R-065 Taping Tool",
            "F": "FerRobotics-ATK-201-R-065-Taping-Tool.robot",
            "I": "FerRobotics-ATK-201-R-065-Taping-Tool.png",
            "B": "FerRobotics",
            "M": "ATK 201-R-065 Taping Tool",
            "T": "Tool",
            "A": 1,
            "AP": [
                "Taping"
            ]
        },
        "Generic-Pencil-Tool": {
            "MT": "T",
            "N": "Generic Pencil Tool",
            "F": "Generic-Pencil-Tool.tool",
            "I": "Generic-Pencil-Tool.png",
            "M": "Pencil Tool",
            "T": "Tool",
            "A": 0,
            "W": 2
        },
        "OnRobot-Angle-Bracket": {
            "MT": "T",
            "N": "OnRobot Angle Bracket",
            "F": "OnRobot-Angle-Bracket.tool",
            "I": "OnRobot-Angle-Bracket.png",
            "B": "OnRobot",
            "M": "Angle Bracket",
            "T": "Tool",
            "A": 0
        },
        "OnRobot-HEX-Force-Torque-Sensor": {
            "MT": "T",
            "N": "OnRobot HEX Force/Torque Sensor",
            "F": "OnRobot-HEX-Force-Torque-Sensor.tool",
            "I": "OnRobot-HEX-Force-Torque-Sensor.png",
            "B": "OnRobot",
            "M": "HEX Force/Torque Sensor",
            "T": "Tool",
            "A": 0
        },
        "SMC-2-9409-1-50-4-M6-DUA00831-Bracket": {
            "MT": "T",
            "N": "SMC 2-9409-1-50-4-M6-DUA00831 Bracket",
            "F": "SMC-2-9409-1-50-4-M6-DUA00831-Bracket.tool",
            "I": "SMC-2-9409-1-50-4-M6-DUA00831-Bracket.png",
            "B": "SMC",
            "M": "2-9409-1-50-4-M6-DUA00831 Bracket",
            "T": "Tool",
            "A": 0
        },
        "SMC-3-9409-1-50-4-M6-DUA00745-Bracket": {
            "MT": "T",
            "N": "SMC 3-9409-1-50-4-M6-DUA00745 Bracket",
            "F": "SMC-3-9409-1-50-4-M6-DUA00745-Bracket.tool",
            "I": "SMC-3-9409-1-50-4-M6-DUA00745-Bracket.png",
            "B": "SMC",
            "M": "3-9409-1-50-4-M6-DUA00745 Bracket",
            "T": "Tool",
            "A": 0
        },
        "uFactory-6-Axis-Force-Torque-Sensor": {
            "MT": "T",
            "N": "uFactory 6-Axis Force Torque Sensor",
            "F": "uFactory-6-Axis-Force-Torque-Sensor.tool",
            "I": "uFactory-6-Axis-Force-Torque-Sensor.png",
            "B": "uFactory",
            "M": "6-Axis Force Torque Sensor",
            "T": "Tool",
            "A": 0
        },
        "Zivid-On-Arm-Extender-OA01E": {
            "MT": "T",
            "N": "Zivid On-Arm Extender OA01E",
            "F": "Zivid-On-Arm-Extender-OA01E.tool",
            "I": "Zivid-On-Arm-Extender-OA01E.png",
            "B": "Zivid",
            "M": "On-Arm Extender OA01E",
            "T": "Tool",
            "A": 0
        },
        "Zivid-On-Arm-Extender-OA02E": {
            "MT": "T",
            "N": "Zivid On-Arm Extender OA02E",
            "F": "Zivid-On-Arm-Extender-OA02E.tool",
            "I": "Zivid-On-Arm-Extender-OA02E.png",
            "B": "Zivid",
            "M": "On-Arm Extender OA02E",
            "T": "Tool",
            "A": 0
        },
        "Zivid-On-Arm-Mount-OA10": {
            "MT": "T",
            "N": "Zivid On-Arm Mount OA10",
            "F": "Zivid-On-Arm-Mount-OA10.tool",
            "I": "Zivid-On-Arm-Mount-OA10.png",
            "B": "Zivid",
            "M": "On-Arm Mount OA10",
            "T": "Tool",
            "A": 0
        },
        "Zivid-On-Arm-Mount-OA111": {
            "MT": "T",
            "N": "Zivid On-Arm Mount OA111",
            "F": "Zivid-On-Arm-Mount-OA111.tool",
            "I": "Zivid-On-Arm-Mount-OA111.png",
            "B": "Zivid",
            "M": "On-Arm Mount OA111",
            "T": "Tool",
            "A": 0
        },
        "Zivid-On-Arm-Mount-OA121": {
            "MT": "T",
            "N": "Zivid On-Arm Mount OA121",
            "F": "Zivid-On-Arm-Mount-OA121.tool",
            "I": "Zivid-On-Arm-Mount-OA121.png",
            "B": "Zivid",
            "M": "On-Arm Mount OA121",
            "T": "Tool",
            "A": 0
        },
        "Zivid-On-Arm-Mount-OA211": {
            "MT": "T",
            "N": "Zivid On-Arm Mount OA211",
            "F": "Zivid-On-Arm-Mount-OA211.tool",
            "I": "Zivid-On-Arm-Mount-OA211.png",
            "B": "Zivid",
            "M": "On-Arm Mount OA211",
            "T": "Tool",
            "A": 0
        },
        "Zivid-On-Arm-Mount-OA221": {
            "MT": "T",
            "N": "Zivid On-Arm Mount OA221",
            "F": "Zivid-On-Arm-Mount-OA221.tool",
            "I": "Zivid-On-Arm-Mount-OA221.png",
            "B": "Zivid",
            "M": "On-Arm Mount OA221",
            "T": "Tool",
            "A": 0
        },
        "Zivid-Pointed-Hand-Eye-Verification-Tool": {
            "MT": "T",
            "N": "Zivid Pointed Hand-Eye Verification Tool",
            "F": "Zivid-Pointed-Hand-Eye-Verification-Tool.tool",
            "I": "Zivid-Pointed-Hand-Eye-Verification-Tool.png",
            "B": "Zivid",
            "M": "Pointed Hand-Eye Verification Tool",
            "T": "Tool",
            "A": 0
        },
        "Zivid-Two-Field-of-view": {
            "MT": "T",
            "N": "Zivid Two Field-of-view",
            "F": "Zivid-Two-Field-of-view.tool",
            "I": "Zivid-Two-Field-of-view.png",
            "B": "Zivid",
            "M": "Two Field-of-view",
            "T": "Tool",
            "A": 0
        }
    }
}